import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { buildMasterdataHelper } from "../factory";
export const MasterRolesFragment = gql `
  fragment _ on Role {
    id
    name
    nameTranslations {
      locale
      value
    }
    status
    codename
    profQualificationIds
    profQualifications @client {
      id
      name
    }
    allowedScopes
    requiresRelationsToEntities
    canBeGrantedInDisciplineCodenames
  }
`;
export function useRoleHelper() {
    function getRoles() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query MasterRoles {
            roles {
              ${MasterRolesFragment}
            }
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : []);
    }
    const { masterdataEntities, activeEntities, getFromMasterdata, addMissingSelectValue } = buildMasterdataHelper(getRoles);
    function getRolesFromMaster(props = { noSystem: true, active: true }) {
        const { noSystem, active } = props;
        return masterdataEntities.value.filter(role => {
            if (noSystem === true && role.codename != null) {
                return false;
            }
            if (active === true && role.status != "active") {
                return false;
            }
            if (role.status == "new") {
                return false;
            }
            return true;
        });
    }
    return {
        masterRolesAll: masterdataEntities,
        masterRoles: activeEntities,
        getRoleFromMaster: getFromMasterdata,
        withMissingSurveySelect: addMissingSelectValue,
        getRolesFromMaster
    };
}
